module.exports = __webpack_public_path__ + "static/media/home-reload.66209d50.svg";